const { ethers } = require('ethers');

const formatUnitParseFloat = (value, unit = 18) => Number.parseFloat(ethers.utils.formatUnits(`${value}`, unit));

export default { formatUnitParseFloat };
